import { render, staticRenderFns } from "./AlbumSettingsToken.vue?vue&type=template&id=aa0e6a6c&"
import script from "./AlbumSettingsToken.vue?vue&type=script&lang=js&"
export * from "./AlbumSettingsToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports